export default __webpack_public_path__ + "static/media/b.b71ed07e.png";